export default __webpack_public_path__ + "static/media/poppins-semibold.c8a0be17.ttf";